import Link from 'next/link'
import LinkArrow from '../icons/LinkArrow'
import { Card } from 'designsystem/Card'
import { Marketing } from 'designsystem/Text'
import EdgeCachingIcon from 'icons/EdgeCachingIcon'
import MetricsIcon from 'icons/MetricsIcon'
import { FEATURE_EDGE_CACHING, FEATURE_METRICS } from 'common/constants'

interface MoreThanSectionProps extends React.HTMLAttributes<HTMLUListElement> {
  features: Array<FeatureCardProps['feature']>
}

interface FeatureCardProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  feature: 'graphql-edge-caching' | 'graphql-metrics'
}

const MoreThanSection = ({
  features,
  className,
}: MoreThanSectionProps): JSX.Element => {
  return (
    <ul
      className={`flex flex-col space-y-6 sm:space-y-8 xl:space-y-0 xl:space-x-8 xl:flex-row items-center justify-center ${
        className || ''
      }`}
      aria-label='Other features'
    >
      {features.map((feature, key) => (
        <li key={key}>
          <FeatureCard feature={feature} />
        </li>
      ))}
    </ul>
  )
}

export default MoreThanSection

const FeatureCard = ({
  className,
  feature,
  ...props
}: FeatureCardProps): JSX.Element => {
  const iconClasses = 'h-12 w-auto sm:h-16 flex-shrink-0'

  return (
    <Link
      href={`/${feature}`}
      target='_self'
      className={`flex lg:min-w-96 lg:max-w-2xl items-center w-full h-full hover:text-blue focus:text-blue large-body-text ${
        className || ''
      }`}
      {...props}
    >
      <Card
        noPadding
        noMaxWidth
        hoverable
        className='flex items-center justify-between w-full h-full space-x-6 sm:space-x-8 p-6 sm:p-8'
      >
        <div className='flex items-center space-x-6 sm:space-x-8'>
          {feature === 'graphql-edge-caching' && (
            <EdgeCachingIcon
              context='moreThanSection'
              className={iconClasses}
            />
          )}
          {feature === 'graphql-metrics' && (
            <MetricsIcon context='moreThanSection' className={iconClasses} />
          )}
          <Marketing.H4 className='text-neutral'>
            {feature === 'graphql-edge-caching' && FEATURE_EDGE_CACHING}
            {feature === 'graphql-metrics' && FEATURE_METRICS}
          </Marketing.H4>
        </div>

        <LinkArrow className='h-5 w-auto flex-shrink-0 stroke-current sm:h-6 transition-colors' />
      </Card>
    </Link>
  )
}
